import { handleResponse } from 'helper/handleResponse';
import { authHeader } from 'helper/authHeader';
import { baseUrl } from 'helper/ApiCall';

export const userService = {
    storeUser,
    getUser,
    editUser,
    getUsers,
    deleteUser,
    getCurrentUser,
    updatePermission,
    showPassword
}



function storeUser(userData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(userData)
    };

    return fetch(baseUrl + 'users', requestOptions)
        .then(handleResponse)
        .then(company => {
            return company;
        })
}

function showPassword(userData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(userData)
    };

    return fetch(baseUrl + 'users/showPassword', requestOptions)
        .then(handleResponse)
        .then(company => {
            return company;
        })
}

function getUser(userId) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(baseUrl + 'users/' + userId, requestOptions).then(handleResponse);
}

function editUser(userData, userId) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(userData)
    };

    return fetch(baseUrl + 'users/' + userId, requestOptions)
        .then(handleResponse)
        .then(company => {
            return company;
        })
}


function deleteUser(userId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()

    };


    return fetch(baseUrl + 'users/' + userId, requestOptions).then(handleResponse);
}


function getUsers(companyId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    if (companyId)
        return fetch(baseUrl + 'getAllUsers/' + companyId, requestOptions).then(handleResponse);
    else
        return fetch(baseUrl + 'getAllUsers', requestOptions).then(handleResponse);
}

function getCurrentUser() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()

    };
    return fetch(baseUrl + 'getUsersData', requestOptions).then(handleResponse);
}

function updatePermission(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()

    };
    return fetch(baseUrl + 'changePrimaryContact/' + userId, requestOptions).then(handleResponse);
}


// WEBPACK FOOTER //
// ./src/services/user.js